import React, {Component, createRef} from 'react'
import {Icon, Input} from "antd"
import PropTypes from "prop-types"

class CardInput extends Component {
    _input = createRef()

    _handleClear = () => {
        this._input.current.focus()

        const {onClose} = this.props
        onClose()
    }

    render() {
        const {error, errors, loading, value, onChangeInput, onSubmit} = this.props

        return (
            <form onSubmit={onSubmit} className='mb-3'>
                <div className='position-relative'>
                    <Input size='large' autoFocus
                           readOnly={loading}
                           value={value}
                           onChange={onChangeInput}
                           placeholder="Nhập item cần đánh dấu."
                           ref={this._input}
                           className='InputSearch'/>

                    {value && <div onClick={this._handleClear} className='position-absolute IconClear'>
                        <Icon type="close-circle" theme="filled"/>
                    </div>}
                </div>
                {error && <div className="mt-3 text-danger">{error}</div>}
                {errors.length > 0 && (
                    <div className="mt-3 text-danger">
                        {
                            errors.map((itemErr, indexErr) => {
                                return <div key={indexErr}>{itemErr}</div>
                            })
                        }
                    </div>
                )}
            </form>
        )
    }
}

CardInput.propTypes = {
    error: PropTypes.string,
    errors: PropTypes.array,
    loading: PropTypes.bool.isRequired,
    value: PropTypes.string,
    onChangeInput: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
}

export default CardInput